export default "__VITE_PUBLIC_ASSET__c4e11276__"